module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/95/assets/images/e31f45cbb53e98ce053f50e2dfc864fa.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Emerald/Emerald1.svg
// module id = R1VL
// module chunks = 1